import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import Index from "@/components/Index";
import WannaAudit from "@/components/landings/WannaAudit";
import WannaStartup from "@/components/landings/WannaStartup";
import City from "@/components/City";
import WannaCodeReview from "@/components/landings/WannaCodeReview";

import 'material-design-icons-iconfont'
import Past from "@/components/Past";
import LevelUpAtProfa_2021_03_04 from "@/components/levelup/LevelUpAtProfa_2021_03_04";
import LevelUpAtProfa_2020_09_17 from "./components/levelup/LevelUpAtProfa_2020_09_17";
import QR from "@/components/QR";
import LevelUpPublic_2021_08_12 from "@/components/levelup/LevelUpPublic_2021_08_12";
import Present from "@/components/Present";
import Burnout from "@/components/papers/Burnout";
import Carbonara from "@/components/food/Carbonara";
import LevelUpPublic_Invite from "@/components/levelup/LevelUpPublic_Invite";
import BurnoutConsulting from "@/components/BurnoutConsulting";
import WannaCoaching from "@/components/landings/WannaCoaching";
import SunWoodTower from "@/components/products/SunWoodTower";

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import LittleRaccoon from "@/components/kids/LittleRaccoon";
import ClubPi from "@/components/pi/ClubPi";
import Sorry from "@/components/papers/Sorry";
import LoveBase from "@/components/love/LoveBase";

Vue.use(VueRouter)
Vue.use(VuePlyr, {
  plyr: {}
})

Vue.config.productionTip = false

const routes = [
  { path: '/levelupatprofa/1', component: LevelUpAtProfa_2020_09_17,
    props: (route) => ({secret: route.query.secret,}) },
  { path: '/levelupatprofa/2', component: LevelUpAtProfa_2021_03_04,
    props: (route) => ({secret: route.query.secret,}) },
  { path: '/leveluppublic/3', component: LevelUpPublic_2021_08_12,
    props: (route) => ({secret: route.query.secret,}) },
  { path: '/leveluppublic/invite', component: LevelUpPublic_Invite },
  { path: '/pi/invite', component: ClubPi },
  { path: '/burnoutconsulting', component: BurnoutConsulting },
  { path: '/papers/1', component: Burnout },
  { path: '/papers/2', component: Sorry },
  { path: '/love/base', component: LoveBase },
  { path: '/food/carbonara', component: Carbonara },
  { path: '/products/sun-wood-tower', component: SunWoodTower },
  { path: '/wanna/audit', component: WannaAudit },
  { path: '/wanna/startup', component: WannaStartup },
  { path: '/wanna/codereview', component: WannaCodeReview },
  { path: '/wanna/coaching', component: WannaCoaching },
  { path: '/kids/little-racoon', component: LittleRaccoon },
  { path: '/past', component: Past },
  { path: '/present', component: Present },
  { path: '/city', component: City },
  { path: '/qr', component: QR },
  { path: '/', component: Index },
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.

//mode: 'history',

const router = new VueRouter({
  
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  }
})

// 4. Create and mount the root instance.
// Make sure to inject the router with the router option to make the
// whole app router-aware.
new Vue({
  render: (h) => h(App),
  router
}).$mount('#app')

// new Vue({
//   render: h => h(App),
// }).$mount('#app')
